import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import FixturePage from "./pages/FixturePage";

function App() {
  return (
    <div
    style={{
      backgroundImage: "url('/team-logos/champions-league.jpeg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}
  >
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/fixture" element={<FixturePage />} />
    </Routes>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
